<template>
  <component
    :is="href ? 'a' : tag"
    :href="href"
    class="def-link-brown"
    :class="{ 'def-link-brown_disabled': disabled }"
    :target="target"
    :type="isButton ? 'button' : undefined"
    :disabled="isButton ? disabled : undefined"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefLinkBrown',
  props: {
    href: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '_self',
    },
    /** element without href: 'span' or 'button' (focusable from the keyboard) */
    tag: {
      type: String,
      default: 'span',
      validator: (value) => ['span', 'button'].includes(value),
    },
  },
  computed: {
    isButton() {
      return !this.href && this.tag === 'button';
    },
  },
};
</script>

<style lang="scss" scoped>
.def-link-brown {
  display: inline-block;
  cursor: pointer;
  color: var(--color-golden-browm);
  transition: 0.2s linear color;
  &_disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
}
a.def-link-brown {
  //text-decoration-color: currentColor;
  &:hover {
    text-decoration-line: underline;
    text-underline-position: under;
  }
}
// :where keeps specificity low, so a class from the parent can still set the font
:where(button.def-link-brown) {
  font: inherit;
  text-align: inherit;
}
a.def-link-brown,
button.def-link-brown {
  &:focus-visible {
    outline: 1px solid currentColor;
    outline-offset: 2px;
  }
}
</style>
